// utils/tutorials.ts
import { createClient } from "@repo/shared/supabase/client";

export async function getTutorials() {
    const supabase = createClient();
    const { data, error } = await supabase.from('tutorials').select().eq('deleted', false);

    if (error) {
        console.error("Error fetching tutorials:", error);
        return [];
    }

    return data || [];
}

// Module-level cache for client-side components
let tutorialsCache: any[] | null = null;
let lastFetchTime = 0;
const CACHE_DURATION = 1000 * 60 * 60; // 1 hour cache duration

export async function getTutorialsWithCache() {
    // Check if we have cached data that's still fresh
    const now = Date.now();
    if (tutorialsCache && now - lastFetchTime < CACHE_DURATION) {
        return tutorialsCache;
    }

    try {
        const tutorials = await getTutorials();
        // Update the cache
        tutorialsCache = tutorials;
        lastFetchTime = now;
        return tutorials;
    } catch (err) {
        console.error("Failed to fetch tutorials:", err);
        return [];
    }
}